module.exports = __webpack_public_path__ + "img/sovteh-logo.d339e73e.svg";